<template>
  <div class="container-fluid">
    <Card back>
      <template slot="header">
        <h3>ارسال ایمیل</h3>
        <hr />
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-lg-5 col-12">
            <small id="LblGetEmail">انتخاب ایمیل</small>
            <SearchableCombo :edit="false" :grp="$session.get('UserInfo').tblUserId" :code="null" @ResultCombo="GetEmail" :rownumintable="3" :action="'TblCrmCombo/GetEmailByUser'" :method="'POST'" :idinput="'GetEmail'" :keyItem="'GetEmail'" :disabled="false" :ClassProps="'required'">
            </SearchableCombo>
          </div>
          <div class="col-lg-2 col-12"></div>
          <div class="col-lg-5 col-12">
            <small id="LblGetEmail">انتخاب ایمیل</small>
            <input type="email" class="form-control text-left" dir="ltr" v-model="EmailData.ToEmail" />
          </div>
          <div class="col-12 px-4">
            <input type="text" placeholder="موضوع" class="form-control" v-model="EmailData.Subject" />
          </div>
          <div class="col-12 px-4 mt-2">
            <textarea name="body" id="emailbody" class="form-control" placeholder="متن ایمیل" cols="30" v-model="EmailData.Body" rows="10"></textarea>
          </div>
          <div class="col-12 px-4 mt-2">
            <div class="row">
              <div class="col-1">
                <button class="btn btn-outline-warning" @click="clickuploader"><i class="fas fa-paperclip"></i></button>
                <input @change="uploadfile" type="file" class="d-none" id="input" />
              </div>
              <div class="col-11">
                <span class="badge badge-warning mx-1" v-for="(item, index) in EmailData.Attachments" :key="index"> {{ item.name }} &nbsp;&nbsp;&nbsp; <i class="fas fa-times Pointer" @click="deletefile(index)"></i></span>
              </div>
            </div>
          </div>
          <div class="col-lg-8 col-12"></div>
          <div class="col-lg-4 col-12">
            <button @click="SendEmail" class="btn btn-success mt-2 w-100">ارسال <i class="fad fa-paper-plane"></i></button>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
export default {
  data() {
    return {
      EmailData: null,
      emptyMail: {
        EmailID: null,
        Attachments: [],
        Body: null,
        Subject: null,
        ToEmail: null,
      },
    }
  },
  methods: {
    GetEmail(data) {
      if (data.id != null) {
        // console.log(data)
        this.EmailData.EmailID = data.id
      }
    },
    clickuploader() {
      document.getElementById('input').click()
    },
    uploadfile() {
      this.EmailData.Attachments.push(document.getElementById('input').files[0])
    },
    deletefile(index) {
      this.EmailData.Attachments.splice(index, 1)
    },
    SendEmail() {
      this.$mySweetDefaultTost('درحال ارسال', '', 'info')
      if (this.EmailData.ToEmail == null || this.EmailData.ToEmail.indexOf('@') < 0) {
        this.$mySweetDefault('عملیات ناموفق', 'آدرس ایمیل گیرنده را به صورت صحیح وارد کنید', 'warning', 1500)
        return
      } else if (this.EmailData.EmailID == null) {
        this.$mySweetDefault('عملیات ناموفق', 'ایمیل ارسال کننده انتخاب نشده است!', 'warning', 1500)
        return
      } else {
        var formData = new FormData()
        formData.append('ToEmail', this.EmailData.ToEmail)
        formData.append('Subject', this.EmailData.Subject)
        formData.append('Body', this.EmailData.Body)
        formData.append('Attachments', null)
        formData.append('EmailID', this.EmailData.EmailID)
        this.EmailData.Attachments.forEach((element, index) => {
          formData.append('Attachment' + index, element)
        })
        var DataAxios = {
          Method: 'post',
          Action: 'Mail',
          ArryfildValue: formData,
        }
        this.$PostFormData(DataAxios).then((result) => {
          if (result.status == 'success') {
            this.$mySweetDefaultTost('ارسال موفق', '', 'success', 1500)
            this.empty()
          } else {
            this.$mySweetDefaultTost('خطا ', result.msg, 'warning', 2000)
          }
        })
      }
    },
    empty() {
      this.EmailData = JSON.parse(JSON.stringify(this.emptyMail))
    },
  },
  mounted() {
    this.empty()
  },
  components: { Card, SearchableCombo },
}
</script>
